import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface TrainingDetailsModalData {
    trainingId: string;
}

@Component({
    selector: 'training-details-modal',
    templateUrl: './trainingDetailsModal.component.html',
    styleUrls: ['./trainingDetailsModal.component.scss']
})
export class TrainingDetailsModalComponent implements OnInit {
    trainingId: string;

    constructor(
        public dialogRef: MatDialogRef<TrainingDetailsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: TrainingDetailsModalData
    ) {
        this.trainingId = data.trainingId;
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialogRef.close();
    }
}